import React, { Fragment, useState } from "react"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import compose from "ramda/src/compose"
import _get from "lodash/get"
import PropTypes from "prop-types"

import DefaultContainer from "shared/components/DefaultContainer"
import DefaultTitle from "shared/components/DefaultTitle"
import EmptyState from "shared/components/EmptyState"
import PhoneOptions, { months, years } from "./components/PhoneOptions"
import PrePaidDocumentsContainer from "./components/PrePaidDocuments/PrePaidDocumentsContainer"
import iconError from "../../assets/svg/erro-desbloqueio.svg"

import { saveOperation } from "services/state/actions"
import {
  listInvoiceRecharges,
  downloadInvoiceRecharge,
  downloadMultipleInvoiceRecharges
} from "services/state/invoiceRecharges/action"
import { maskTelCustom } from "services/utils/mask"

const RechargeDocuments = ({
  t,
  products,
  listInvoiceRecharges,
  downloadInvoiceRecharge,
  downloadMultipleInvoiceRecharges,
  customer,
  saveOperation
}) => {
  const [selectedPhone, setSelectedPhone] = useState(null)
  const [documents, setDocuments] = useState([])

  const [loadingSearch, setLoadingSearch] = useState(false)

  const [selectedMonth, setSelectedMonth] = useState(months[0])
  const [selectedYear, setSelectedYear] = useState(years[0])
  const [documentType, setDocumentType] = useState("NOTAFISCAL")

  const isProductsError = _get(products, "error", false)

  const prePaidNumbers =
    products.data.flatMap((item) =>
      item.products
        .filter((p) => p.paymentMode === "PREPAGO" && p.status === "ATIVO")
        .map((p) => ({
          value: p.assetTag,
          label: `${maskTelCustom(p.assetTag)} - ${p.assetFullName}`
        }))
    ) || []

  const searchDocuments = (phone, month, year, type) => {
    const phoneParam = phone.value
    if (!phoneParam) return

    const currentYearStr = new Date().getFullYear().toString()

    const selectedMonthValue = month.value
    const selectedYearValue = year.value

    const yearParam = selectedYearValue || currentYearStr
    const monthParam = selectedMonthValue || "01"
    const typeParam =
      type === "NOTAFISCAL" ? ["NOTAFISCAL", "NFCOM"] : ["FATURA"]

    setLoadingSearch(true)

    listInvoiceRecharges(
      {
        invoiceNumber: phoneParam,
        year: yearParam,
        month: monthParam,
        type: typeParam
      },
      (response) => {
        const allDocs = response.payload.data || []

        const filteredDocs = allDocs.filter((doc) => {
          if (!doc.monthYear) return false
          const [docMonth, docYear] = doc.monthYear.split("/")

          const yearMatch = !selectedYearValue || docYear === selectedYearValue

          const monthMatch =
            !selectedMonthValue || docMonth === selectedMonthValue

          return yearMatch && monthMatch
        })

        setDocuments(filteredDocs)
        setLoadingSearch(false)
      },
      (error) => {
        console.error("Erro ao carregar documentos:", error)
        setLoadingSearch(false)
      }
    )
  }

  const handleChange = (selected) => {
    const defaultMonth = months[0]
    const defaultYear = years[0]
    const defaultDocumentType = "NOTAFISCAL"

    setSelectedPhone(selected)
    setSelectedMonth(defaultMonth)
    setSelectedYear(defaultYear)
    setDocuments([])
    setDocumentType(defaultDocumentType)

    if (selected) {
      searchDocuments(selected, defaultMonth, defaultYear, defaultDocumentType)
    }
  }

  const handleSearch = () => {
    searchDocuments(selectedPhone, selectedMonth, selectedYear, documentType)
  }

  const handleDocumentTypeChange = (newType) => {
    const defaultMonth = months[0]
    const defaultYear = years[0]

    setDocumentType(newType)
    setSelectedMonth(defaultMonth)
    setSelectedYear(defaultYear)
    setDocuments([])
    searchDocuments(selectedPhone, defaultMonth, defaultYear, newType)
  }

  const handleMonthChange = (newMonth) => {
    setSelectedMonth(newMonth)

    if (newMonth.value !== "" && selectedYear.value === "") {
      setSelectedYear(years[1])
    }
  }

  const handleYearChange = (newYear) => {
    setSelectedYear(newYear)

    if (newYear.value === "") {
      setSelectedMonth(months[0])
    }
  }

  return (
    <Fragment>
      <DefaultTitle>{t("MSG_0493")}</DefaultTitle>
      {isProductsError ? (
        <EmptyState icon={iconError} description={t("MSG_0433")} />
      ) : (
        <DefaultContainer>
          <PhoneOptions
            prePaidNumbers={prePaidNumbers}
            selectedPhone={selectedPhone}
            onChange={handleChange}
            onSearch={handleSearch}
            selectedMonth={selectedMonth}
            selectedYear={selectedYear}
            onChangeMonth={handleMonthChange}
            onChangeYear={handleYearChange}
          />

          {selectedPhone && (
            <PrePaidDocumentsContainer
              selectedPhone={selectedPhone}
              documents={documents}
              loading={loadingSearch}
              downloadInvoiceRecharge={downloadInvoiceRecharge}
              downloadMultipleInvoiceRecharges={
                downloadMultipleInvoiceRecharges
              }
              documentType={documentType}
              onDocumentTypeChange={handleDocumentTypeChange}
              customer={customer}
              saveOperation={saveOperation}
            />
          )}
        </DefaultContainer>
      )}
    </Fragment>
  )
}

RechargeDocuments.propTypes = {
  t: PropTypes.func,
  products: PropTypes.object,
  listInvoiceRecharges: PropTypes.func,
  downloadInvoiceRecharge: PropTypes.func,
  downloadMultipleInvoiceRecharges: PropTypes.func,
  customer: PropTypes.object,
  saveOperation: PropTypes.func
}

const mapStateToProps = ({ customer, products }) => ({
  customer,
  products
})

const enhance = compose(
  translate(),
  connect(mapStateToProps, {
    saveOperation,
    listInvoiceRecharges,
    downloadInvoiceRecharge,
    downloadMultipleInvoiceRecharges
  })
)

export default enhance(RechargeDocuments)



// WEBPACK FOOTER //
// ./src/components/RechargeDocuments/index.js